var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo } from 'react';
import cc from 'classcat';
import './toggle-button.style.scss';
/**
 * A button specifically for icons
 */
var ToggleButton = function (props) {
    var id = props.id, leftLabel = props.leftLabel, rightLabel = props.rightLabel, checked = props.checked, onSwitch = props.onSwitch, children = props.children, className = props.className, rest = __rest(props, ["id", "leftLabel", "rightLabel", "checked", "onSwitch", "children", "className"]);
    return (React.createElement("label", __assign({ htmlFor: id, className: cc(['tfm-toggle-button', className]) }, rest),
        React.createElement("input", { id: id, type: "checkbox", onChange: onSwitch, checked: checked }),
        React.createElement("div", { className: "tfm-toggle-button-slider" },
            React.createElement("span", { className: "tfm-toggle-button-slider-left" }, leftLabel),
            React.createElement("span", { className: "tfm-toggle-button-slider-right" }, rightLabel))));
};
export default memo(ToggleButton);
